import { Component } from '@angular/core';

import { ImageComponent } from '@frontend/vanilla/shared/image';

import { AccountMenuItemBase } from '../account-menu-item-base';

@Component({
    imports: [ImageComponent],
    selector: 'vn-am-banner',
    templateUrl: 'banner.html',
})
export class BannerComponent extends AccountMenuItemBase {
    constructor() {
        super();
    }
}
